import Debug from '@/util/debug';
import FormInput from '@/components/form-input/FormInput.vue';
import 'vue-awesome/icons/search';
import AutocompleteExtend from '@/directives/autocomplete-extend';

const debug = Debug('facebook-connector');

// TODO put in separate component
const ItemTemplate = {
  props: { item: { required: true } },
  template: `
    <div :title="link">
      <img :src='item.picture' />
      <div class="text">
        <span class="name">{{ item.name }}</span>
        <span class="link">{{ link }}</span>
      </div>
    </div>
  `,
  computed: {
    link() {
      if (!this.item || !this.item.link) {
        return '';
      }

      // remove https://www. (or as much of it as the original link has)
      // reduces the link length (and this is irrelevant info anyway)
      return this.item.link.replace(/^(?:https?:\/\/)?(?:www\.)?/, '');
    },
  },
};

const CLAIM_STATUS = {
  UNKNOWN: 'unknown',
  UNCLAIMED: 'unclaimed',
  CLAIMED: 'claimed',
};

export default {
  dependencies: [
    'facebookPageService',
  ],
  components: {
    'form-input': FormInput,
  },
  directives: [
    AutocompleteExtend,
  ],
  props: {
    page: Object,
  },
  data() {
    return {
      items: [],
      itemTemplate: ItemTemplate,
      selected: null,
      claimsInProgress: 0,
      connectStatus: 'no-page',
    };
  },
  computed: {
    buttonEnabled() {
      return this.selected
        && this.selected.claim !== CLAIM_STATUS.CLAIMED
        && !this.claimsInProgress;
    },
    buttonVariant() {
      if (this.selected && this.selected.claim === CLAIM_STATUS.CLAIMED) {
        return 'success';
      }
      return 'default';
    },
    buttonText() {
      if (this.selected && this.selected.claim === CLAIM_STATUS.CLAIMED) {
        return 'pos.settings.facebook-page.connected';
      }
      return 'pos.settings.facebook-page.connect';
    },
    claimLink() {
      if (!this.selected || this.selected.claim !== CLAIM_STATUS.UNCLAIMED) {
        return false;
      }

      const pageLinkWithSlash = this.page.link.endsWith('/') ? this.page.link : `${this.page.link}/`;

      return `${pageLinkWithSlash}settings?tab=admin_roles`;
    },
  },
  methods: {
    onChange() {
      this.items = [];
      this.$emit('update:page', null);
    },
    onUpdateItems(search) {
      debug.info('onUpdateItems: %s', search);
      this.facebookPageService.autocomplete(search)
        // mark new suggestions as 'unclaimed'
        .then(items => items.map(i => Object.assign({}, i, { claim: CLAIM_STATUS.UNKNOWN })))
        .then(items => this.items = items)
        .catch(err => debug.error(err));
    },
    onConnect() {
      const fin = () => {
        this.claimsInProgress -= 1;
      };

      debug.info('onConnect. Selected: %o', this.selected);
      if (this.selected) {
        this.connectStatus = 'connecting';
        this.claimsInProgress += 1;
        this.facebookPageService.claim(this.selected.id)
          .then(claimed => {
            this.selected.claim = claimed ? CLAIM_STATUS.CLAIMED : CLAIM_STATUS.UNCLAIMED;
            this.$emit('update:page', this.selected);
            if (claimed) {
              this.$toast.success({ message: this.$t('pos.settings.facebook-page.accepted-toast') });
              this.connectStatus = 'connected';
            } else {
              this.$toast.info({ message: this.$t('pos.settings.facebook-page.should-accept-toast') });
              this.connectStatus = 'connected-not-claimed';
            }
            return claimed;
          })
          .then(fin)
          .catch(e => {
            fin();
            this.$toast.error({ message: e });
            this.connectStatus = 'error';
          });
      }
    },
    getLabel(item) {
      return item.name;
    },
    clearSearch() {
      this.selected = null; // On first load user don't have page, so need to clear it
      this.$refs.autocomplete.searchText = null;
      this.onChange();
    },
  },
  watch: {
    page(newPage) {
      this.selected = newPage;
    },
    selected: function watchSelectedPage(newPage) {
      if (!newPage) {
        this.connectStatus = 'no-page';
      } else if (newPage.claim === CLAIM_STATUS.CLAIMED) {
        this.connectStatus = 'connected';
      } else if (newPage.claim === CLAIM_STATUS.UNCLAIMED) {
        this.connectStatus = 'connected-not-claimed';
      } else {
        this.connectStatus = 'new-page';
      }
    },
  },
  mounted() {
    this.selected = this.page;
  },
};



// WEBPACK FOOTER //
// ./src/components/facebook-connector/FacebookConnector.js